<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>I am a warrior, as I look over my homeland, I am reminded of a song of our father’s, and a time of stability, in the constellation of planets. The destiny of all worlds in our system, though each one unique by stages of evolution, cannot exist without protection.</p><br/>
<p style="text-align: center;">Enigma</p><br/>
<table class="tb1" style="width:97%;">
<colgroup>
<col width="63%"/>
<col width="33%"/>
</colgroup>
<tbody>
<tr class="odd">
<td align="left">Enigma</td>
<td class="mgl">Answer this</td>
</tr>
<tr class="even">
<td align="left">You ask why</td>
<td>With each kiss</td>
</tr>
<tr class="odd">
<td align="left">Like the moon at dusk</td>
<td class="mgl">Is there solace</td>
</tr>
<tr class="even">
<td align="left">Or a dawning sky</td>
<td>When received</td>
</tr>
</tbody>
</table>
<table class="tb1" style="width:97%;">
<colgroup>
<col width="62%"/>
<col width="35%"/>
</colgroup>
<thead>
<tr class="header">
<th align="left">A wish</th>
<th align="left">An evening gown</th>
</tr>
</thead>
<tbody>
<tr class="odd">
<td align="left">Or a spell that binds</td>
<td align="left" class="mgl">Torn inside out</td>
</tr>
<tr class="even">
<td align="left">A dish</td>
<td align="left">And believe, in the</td>
</tr>
<tr class="odd">
<td align="left">As thoughts intertwine</td>
<td align="left" class="mgl">Thought</td>
</tr>
<tr class="even">
<td align="left"></td>
<td align="left">Once perceived</td>
</tr>
</tbody>
</table>
<p class="mll">And I thought</p>
<p class="mll">You would know</p>
<p class="mll">So I ask</p>
<p class="mll">Where to go</p>
<p class="mll">Mirroring looking in</p>
<p class="mll">As we search</p>
<p class="mll">Within</p>
<p class="mll">Where to begin</p><br/>
<p>The forces of nature and the changes, occurring in the suns, that surround the central planets and their orbit, as they near the paradox, are now beginning to feel the changes as the blue star moves closer to their place in the universe. The pull of its gravity, its temperature, and UV’s unique to the blue star, are causing global catastrophic happenings that are undeniable. Changes in atmospheric pressures, sunsets are becoming more brilliant, storms more severe and global volcanic eruptions from dead or extinct volcanoes, come to life without warning. I come from the most inner world.</p>
<p>We are the most advanced of all the planets and have created a type of grid that does not replace the OZONE but enhances it. It strengthens and protects our planet from UV’s, produced by the Blue Star that is harmful. And we are just discovering other incredible and unbelievable uses of this grid. I am a part of a new generation of policing diplomat’s that are responsible for integrating the rest of the planets.</p>
<p>Though not as advanced as ours, together under this new technology, we can and must protect them from annihilation.</p>
<p>The blue star syndrome is a recurring solar phenomenon that, every one-hundred-thousand millennium, gives enough time for a species, on each planet, to evolve to a level of intelligence and is then destroyed by the returning blue star. Because it generates so much heat and unknown UV rays it wipes out everything that was, with no records or architecture to give any consideration to existence or happenings.</p>
<p>By using the assaulting light, we can ascend to descend ourselves onto any planet in our system and interact with its occupants, study them and find our way into their order of structure and add our life skills. As we do this we find areas, predetermined by circumference and magnetic anomalies, and gravitational differences of force, where we can set monoliths in certain identified magnetic and gravitational fractures discovered by the two polar placements and the first six monoliths.</p>
<p>We count our planetary orbits as rotations, by fixing star patterns. I am on my 273<sup>rd</sup> life rotation, being a part of the assaulting light we, light streamers, live longer lives than most species. I am only one-quarter of my life’s time, or a recorded, rotation.</p>
<p>We are on a diplomatic relations mission. But for the data found from a time capsule at an archaeologist dig, sent into space by a previous species existing before the last blue star phenomenon, we would not have had knowledge of this destructive consequence happening in our system. That is why we have a future inside.</p><br/>
<p style="text-align: center;"><em>The Web<br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?33efdaf2